// lightgallery init
import $ from "jquery";
import "../lightgallery/js/lightgallery.min.js";


var lg = lightGallery(document.getElementById("facility-gallery"));

$(".slider-gallery-trigger").on("click", function (e) {
    var elements = $(".carousel-item");
    var settings = {
        dynamic: true,
        dynamicEl: elements.map((i, el) => {
            return {
                src: $(el).data("src"),
            };
        }),
    };

    lightGallery(
        document.getElementById("dynamic-facility-gallery"),
        settings
    );
});